module.exports = __webpack_public_path__ + "static/media/pin.0b5e2d35.svg";